import { number, string, array, date } from "yup"

export function ID2(name: string) {
  return number()
    .integer(`Please Enter a valid ${name}`)
    .positive(`Please Enter a valid ${name}`)
    .typeError(`Please Enter a valid ${name}`)
}

export function nullify(type) {
  return type.transform(v => (v || v === 0 ? v : null))
}
export const ID = number()
  .positive("ID Should be greater than 0")
  .label("Unique ID")

export const firstName = string()
  .min(2, "First Should be atleast 2 characters!")
  .max(60, "First name should not exceed 60 characters!")
  .label("First Name")

export const lastName = string()
  .min(2, "Last Should be atleast 2 characters!")
  .max(60, "Last name should not exceed 60 characters!")
  .label("Last Name")

export const phoneNumber = string()
  .matches(/^(\+91[-\s]?)?[0]?(91)?[6789]\d{9}$/, "Invalid Phone Number")
  .label("Phone Number")

export const email = string().email("Email is invalid!").label("E-Mail")

export const registrationNumber = string().matches(
  /(^[A-Z]{3}[0-9]{1,4}$)|^([A-Z]{2}[0-9]{1,2}(?:[A-Z])?(?:[A-Z]*)?[0-9]{4}$)/,
  "Invalid Vehicle Registration Number!"
)

export const dateRange = array(date())
  .max(2, "Date Range can only have 2 dates!")
  .label("Date Range")
